import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified, getRoleForMutation } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type {
  ComponentChecklist,
  ComponentChecklistAdditionalFields,
  ComponentChecklistDocument,
} from './componentChecklist.types';

export const componentChecklistPullQueryBuilder = (document: ComponentChecklist) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query componentChecklistFeed($siteId: Int!, $disciplineId: Int!, $lastRequested: DateTime!) {
      componentChecklistFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
      ) {
        inspectionId
        pk_AssetInspectionComponentChecklist
        pk_uuid
        isDelete
        assetCategoryComponent
        fk_Component
        checkListComponentName
        site
        discipline
        dateCreated
        dateModified
        inspectionTaskId
        fkInspectorField
        fkInspectorLead
      }
    }
  `);

  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.site,
        doc.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};

export const componentChecklistPushQueryBuilder = (doc: ComponentChecklistDocument[]) => {
  const document = doc[0];
  const query = print(gql`
    mutation saveDeleteComponentCheckList(
      $role: Int!
      $MobileAssetInspectionComponentChecklistInfoInput: MobileAssetInspectionComponentChecklistInfoInput
    ) {
      saveDeleteComponentCheckList(
        role: $role
        componentsChecklist: $MobileAssetInspectionComponentChecklistInfoInput
      ) {
        pk_AssetInspectionComponentChecklist
        pk_uuid
        status
      }
    }
  `);

  const role = getRoleForMutation(document);

  const variables = {
    role,
    MobileAssetInspectionComponentChecklistInfoInput: document,
  };
  return {
    query,
    variables,
  };
};

export const componentChecklistPushModifier = (doc: ComponentChecklistDocument) => {
  const obj: ComponentChecklistDocument & ComponentChecklistAdditionalFields = {
    ...doc,
  };
  if (obj.pk_AssetInspectionComponentChecklist === '0') {
    obj.pk_AssetInspectionComponentChecklist = undefined;
  }
  const blackListedProp = [
    '_attachments',
    '_rev',
    '_deleted',
    'dateCreated',
    'dateModified',
    '_meta',
    'isDeleted',
  ];
  blackListedProp.forEach(property => {
    obj[property as keyof ComponentChecklistAdditionalFields] = undefined;
  });
  return obj;
};
